<!--
  ~ Copyright (c) 2023 D2ArmorPicker by Mijago.
  ~
  ~ This program is free software: you can redistribute it and/or modify
  ~ it under the terms of the GNU Affero General Public License as published
  ~ by the Free Software Foundation, either version 3 of the License, or
  ~ (at your option) any later version.
  ~
  ~ This program is distributed in the hope that it will be useful,
  ~ but WITHOUT ANY WARRANTY; without even the implied warranty of
  ~ MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
  ~ GNU Affero General Public License for more details.
  ~
  ~ You should have received a copy of the GNU Affero General Public License
  ~ along with this program.  If not, see <http://www.gnu.org/licenses/>.
  -->

<table>
  <tr *ngFor="let enum of stats; let i = index">
    <td>
      {{ enum.name }}
    </td>
    <td><app-stat-icon [stat]="enum.value"></app-stat-icon></td>
    <td>
      <app-stat-tier-selection
        [stat]="enum.value"
        [statsByMods]="statsByMods[enum.value]"
        [maximumAvailableTier]="maximumPossibleTiers[enum.value]"
        [selectedTier]="minimumStatTiers[enum.value].value"
        [locked]="minimumStatTiers[enum.value].fixed"
        (selectedTierChange)="setSelectedTier(enum.value, $event)"
        (lockedChange)="setLockState(enum.value, $event)"
        [tabIndexOffset]="i * 10"></app-stat-tier-selection>
    </td>
  </tr>
</table>

<span id="tierSelectButtonContainer">
  <span class="tierSelectButton">
    <button mat-stroked-button color="warn" id="clearStatButton" (click)="clearStatSelection()"
      >Clear</button
    >
  </span>
</span>

<br />
<br />
<!-- modOptimizationStrategy -->
<div>
  <div><b>Mod optimization strategy:</b></div>
  <div>You can choose if the algorithm should keep an eye on amount or the cost of mods.</div>
  <div>These settings are extremely expensive when paired with the reduced waste feature.</div>
  <mat-button-toggle-group
    [(ngModel)]="config_mod_strategy"
    (change)="setModOptimizationStrategy()">
    <mat-button-toggle
      [value]="0"
      matTooltip="Fast. Will result in good and fast results. Some better results *may* be skipped."
      >No extra logic (fast)</mat-button-toggle
    >
    <mat-button-toggle
      [value]="1"
      matTooltip="Slower. Reduces the amount of used mods. This means that it will try to give you 4 mods instead of 5 whenever possible."
      >Fewer mods, high cost (slow)</mat-button-toggle
    >
    <mat-button-toggle
      [value]="2"
      matTooltip="Slower. Reduces the total cost of mods. This will result in less Super mods, for example."
      >Many mods, low cost (slow)</mat-button-toggle
    >
  </mat-button-toggle-group>
</div>
